import { Dispatch, FC, SetStateAction, useState } from 'react';
import { NotificationsMeetingsPublicAssignments } from './NotificationsMeetingsPublicAssignments';
import { NotificationsMeetingsPublicAvUshers } from './NotificationsMeetingsPublicAvUshers';
import { NotificationsMeetingsPublicCleaning } from './NotificationsMeetingsPublicCleaning';
import { notificationTypes } from '@monorepo/helpers';
import { RadioSelector } from 'src/components/_commons';
import { typeNotificationsDoc, typeMeetingsDoc, typeUser, typeNotificationType } from '@monorepo/models';

type propsType = {
    meetingsDoc: typeMeetingsDoc;
    notificationsDoc: typeNotificationsDoc;
    setRefreshCounter: Dispatch<SetStateAction<number>>;
    users: typeUser[];
};

export const NotificationsMeetingsPublic: FC<propsType> = ({ meetingsDoc, notificationsDoc, setRefreshCounter, users }) => {
    const [radioValue, setRadioValue] = useState<typeNotificationType>('meetings-public-assignment');

    return (
        <div>
            <RadioSelector
                additionalKey={'M'}
                buttonWidth={'300px'}
                options={notificationTypes.filter(nt => nt.isPublicMeeting)}
                radioValue={radioValue}
                setRadioValue={setRadioValue}
            />
            {radioValue === 'meetings-public-assignment' &&
                <NotificationsMeetingsPublicAssignments
                    meetingsDoc={meetingsDoc}
                    notificationsDoc={notificationsDoc}
                    setRefreshCounter={setRefreshCounter}
                    users={users}
                />
            }
            {radioValue === 'meetings-public-av-ushers' &&
                <NotificationsMeetingsPublicAvUshers
                    meetingsDoc={meetingsDoc}
                    notificationsDoc={notificationsDoc}
                    setRefreshCounter={setRefreshCounter}
                    users={users}
                />
            }
            {radioValue === 'meetings-public-cleaning' &&
                <NotificationsMeetingsPublicCleaning
                    meetingsDoc={meetingsDoc}
                    notificationsDoc={notificationsDoc}
                    setRefreshCounter={setRefreshCounter}
                    users={users}
                />
            }
        </div>
    );
}
